import React, { Component } from 'react'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'
import ImmutableProptypes from 'react-immutable-proptypes'
import Modal from 'react-modal'

import {
  getCollaborators,
  getInvitesSent,
  getInvitesReceived,
  getNotesSent,
  removeCollab,
  sendCollabInvite,
  acceptCollabInvite,
  ignoreCollabInvite,
  removeCollabInvite,
  remindCollabInvite,
  createCollabNote,
  updateCollabNote,
  deleteCollabNote,
  archiveCollabNote,
} from '_modules/collaboration/actions'

import ListCard from './list-card'
import InviteCard from './invite-card'
import InviteForm from './invite-form'
import NoteForm from './note-form'
import styles from './styles.css'

Modal.setAppElement('body')

const mapStateToProps = ({ user, collab }) => ({
  user,
  collab,
})

const mapDispatchToProps = {
  getCollaborators,
  getInvitesSent,
  getInvitesReceived,
  getNotesSent,
  removeCollab,
  sendCollabInvite,
  acceptCollabInvite,
  ignoreCollabInvite,
  removeCollabInvite,
  remindCollabInvite,
  createCollabNote,
  updateCollabNote,
  deleteCollabNote,
  archiveCollabNote,
}

class CollabPanel extends Component {
  static propTypes = {
    user: ImmutableProptypes.map,
    collab: ImmutableProptypes.map,
    getCollaborators: PropTypes.func.isRequired,
    getInvitesSent: PropTypes.func.isRequired,
    getInvitesReceived: PropTypes.func.isRequired,
    getNotesSent: PropTypes.func.isRequired,
    removeCollab: PropTypes.func.isRequired,
    sendCollabInvite: PropTypes.func.isRequired,
    acceptCollabInvite: PropTypes.func.isRequired,
    ignoreCollabInvite: PropTypes.func.isRequired,
    removeCollabInvite: PropTypes.func.isRequired,
    remindCollabInvite: PropTypes.func.isRequired,
    createCollabNote: PropTypes.func.isRequired,
    updateCollabNote: PropTypes.func.isRequired,
    deleteCollabNote: PropTypes.func.isRequired,
    archiveCollabNote: PropTypes.func.isRequired,
  }

  static defaultProps = {
    user: new Map(),
    collab: new Map(),
  }

  state = {
    collabCards: [],
    receivedInviteCards: [],
    sentInviteCards: [],
    modalIsOpen: false,
    showInviteForm: false,
    showNoteForm: false,
    showConfirm: false,
    toUserId: '',
    noteData: {},
    deleteCollabId: '',
    deleteCollabName: '',
  }

  componentWillMount() {
    this.callApis()
    this.getState(this.props)
  }

  componentWillReceiveProps(nextProps) {
    this.getState(nextProps)
  }

  getState = props => {
    const receivedInviteCards = props.collab.get('invitesReceived').toArray()
    const sentInviteCards = props.collab.get('invitesSent').toArray()
    const notesSent = props.collab.get('notesSent').toArray()
    const collabCards = props.collab
      .get('collaborators')
      .toArray()
      .map(c => {
        const tempC = { ...c, noteStatus: 0 }
        const foundNote = notesSent.find(
          note => note.toUser && note.toUser._id === c.collaborator._id && note.noteStatus < 4
        )

        if (foundNote) {
          tempC.noteStatus = foundNote.noteStatus
        }

        return tempC
      })
      .sort((a, b) => {
        if (a.collaborator.name > b.collaborator.name) return 1
        return -1
      })

    this.setState({
      collabCards,
      receivedInviteCards,
      sentInviteCards,
    })
  }

  onInviteClick = () => {
    this.setState({
      modalIsOpen: true,
      showInviteForm: true,
    })
  }

  onSendMessageCard = id => {
    const notesSent = this.props.collab.get('notesSent').toArray()
    const noteData = notesSent.find(x => x.toUser && x.toUser._id === id && x.noteStatus < 4)

    this.setState({
      modalIsOpen: true,
      showNoteForm: true,
      toUserId: id,
      noteData,
    })
  }

  callApis = () => {
    this.props.getCollaborators()
    this.props.getInvitesSent()
    this.props.getInvitesReceived()
    this.props.getNotesSent()
  }

  deleteCollabCard = (deleteCollabId, deleteCollabName) => {
    this.setState({ modalIsOpen: true, showConfirm: true, deleteCollabId, deleteCollabName })
  }

  acceptCard = id => {
    this.props.acceptCollabInvite({ inviteId: id }).then(this.callApis)
  }

  ignoreCard = id => {
    this.props.ignoreCollabInvite({ inviteId: id }).then(this.callApis)
  }

  cancelCard = id => {
    this.props.removeCollabInvite({ inviteId: id })
  }

  resendCard = id => {
    this.props.remindCollabInvite({ inviteId: id })
  }

  onSendInvite = payload => {
    this.props.sendCollabInvite(payload)
  }

  onSendNote = payload => {
    this.props.createCollabNote(payload)
  }

  onUpdateNote = payload => {
    this.props.updateCollabNote(payload)
  }

  onDeleteNote = noteId => {
    this.props.deleteCollabNote({ noteId })
  }

  onArchiveNote = noteId => {
    this.props.archiveCollabNote({ noteId })
  }

  onDeleteConfirm = () => {
    const { deleteCollabId: inviteId } = this.state
    this.props.removeCollab({ inviteId })
    this.callApis()
    this.closeModal()
  }

  onDeleteCancel = () => {}

  afterOpenModal = () => {
    // focus form input
  }

  closeModal = () =>
    this.setState({
      modalIsOpen: false,
      showInviteForm: false,
      showNoteForm: false,
      showConfirm: false,
      toUserId: '',
      noteData: {},
      deleteCollabId: '',
      deleteCollabName: '',
    })

  renderCollabCards = card => {
    return (
      <ListCard
        key={card._id}
        invitationId={card.invitationId}
        toUserId={card.collaborator._id}
        name={card.collaborator.name}
        email={card.collaborator.email}
        status={card.collaborator.status}
        noteStatus={card.noteStatus}
        deleteCard={this.deleteCollabCard}
        sendNoteCard={this.onSendMessageCard}
      />
    )
  }

  renderReceivedInviteCards = card => {
    const name = `${card.fromUser.name.first} ${card.fromUser.name.last}`
    return (
      <InviteCard
        key={card._id}
        id={card._id}
        name={name}
        email={card.fromUser.email}
        isReceivedInvite
        acceptCard={this.acceptCard}
        ignoreCard={this.ignoreCard}
        cancelCard={this.cancelCard}
        resendCard={this.resendCard}
      />
    )
  }

  renderSentInviteCards = card => {
    return (
      <InviteCard
        key={card._id}
        id={card._id}
        name={card.toName}
        email={card.toEmail}
        isReceivedInvite={false}
        acceptCard={this.acceptCard}
        ignoreCard={this.ignoreCard}
        cancelCard={this.cancelCard}
        resendCard={this.resendCard}
      />
    )
  }

  render() {
    const { user } = this.props
    const {
      collabCards,
      receivedInviteCards,
      sentInviteCards,
      showInviteForm,
      showNoteForm,
      showConfirm,
      deleteCollabName,
    } = this.state

    return (
      <div className={styles.container}>
        <div style={{ flex: 0.9, overflowY: 'scroll' }}>
          {collabCards.map(this.renderCollabCards)}
          {receivedInviteCards.map(this.renderReceivedInviteCards)}
          {sentInviteCards.map(this.renderSentInviteCards)}
        </div>
        <div style={{ flex: 0.1 }}>
          <button className={styles.button} onClick={this.callApis}>
            Refresh
          </button>
          <button className={styles.button} onClick={this.onInviteClick}>
            Invite
          </button>
        </div>
        <Modal
          isOpen={this.state.modalIsOpen}
          onAfterOpen={this.afterOpenModal}
          onRequestClose={this.closeModal}
          className={styles.modal}
          overlayClassName={styles.overlay}
          shouldCloseOnOverlayClick
        >
          {showInviteForm && (
            <InviteForm
              fromName={user.get('name')}
              onSend={this.onSendInvite}
              onCancel={this.closeModal}
              displayError={this.props.displayError}
            />
          )}
          {showNoteForm && (
            <NoteForm
              noteData={this.state.noteData}
              toUser={this.state.toUserId}
              onUpdate={this.onUpdateNote}
              onSend={this.onSendNote}
              onCancel={this.closeModal}
              onDelete={this.onDeleteNote}
              onArchive={this.onArchiveNote}
              displayError={this.props.displayError}
            />
          )}
          {showConfirm && (
            <div
              style={{
                width: '100%',
                display: 'flex',
                alignItems: 'center',
                flexDirection: 'column',
              }}
            >
              <div style={{ fontSize: 20, color: 'white', paddingBottom: 20 }}>
                Delete Collaborator?
              </div>
              <div
                style={{ fontSize: 16, color: 'rgba(255,255,255,0.9)' }}
              >{`Confirming will delete ${deleteCollabName} as collaborator.`}</div>
              <div>
                <button
                  className={styles.modalButton}
                  onClick={this.onDeleteConfirm}
                  style={{ backgroundColor: 'rgba(210,71,62,0.8)' }}
                >
                  {`Remove ${deleteCollabName}`}
                </button>
                <button className={styles.modalButton} onClick={this.closeModal}>
                  Cancel
                </button>
              </div>
            </div>
          )}
        </Modal>
      </div>
    )
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CollabPanel)



// WEBPACK FOOTER //
// ./src/views/collaborate/collaborator-panel/index.js